interface StarRatingProps {
  rating: number
  count: number
}

export function StarRating({ rating, count }: StarRatingProps) {
  const full  = Math.floor(rating)
  const half  = rating - full >= 0.25 && rating - full < 0.75 ? 1 : 0
  const empty = 5 - full - half

  return (
    <div className="fq-star-rating" aria-label={`${rating.toFixed(1)} out of 5, ${count} reviews`}>
      <span className="fq-stars" aria-hidden="true">
        {'★'.repeat(full)}
        {half ? '½' : ''}
        {'☆'.repeat(empty)}
      </span>
      <span className="fq-review-count">({count})</span>
    </div>
  )
}
